'use client';

import { authClient } from '@/lib/auth/client';

import Footer from '../Footer';
import LoginView from './Login';
import AccountView from './Account';
import ProfileLoadingView from './ProfileLoading';

import styles from './Profile.module.sass';

export default function Profile() {
  const { data: session, isPending } = authClient.useSession();

  return (
    <div className={styles.main}>
      {isPending ? (
        <ProfileLoadingView />
      ) : session ? (
        <AccountView session={session} />
      ) : (
        <LoginView />
      )}
      <Footer />
    </div>
  );
}
